import { useEffect, useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import { Company, User } from '@/shared/api';
import { EQueryKeys } from '@/shared/config';

import { companiesQuery, personalQuery } from '../api';
import { useCompanyIdStore, usePersonalStore } from '../model';

export const usePersonalController = () => {
  const [isLoading, setIsLoading] = useState(true);

  const setUser = usePersonalStore((state) => state.setUser);
  const setCompany = usePersonalStore((state) => state.setCompany);

  const setCompanyId = useCompanyIdStore((state) => state.setCompanyId);

  const { data: user, isLoading: isLoadingUser } = useQuery({
    queryKey: [EQueryKeys.PersonalQueryKey],
    queryFn: personalQuery,
    enabled: Boolean(localStorage.getItem('@accessToken')),
  });

  const { data: companies, isLoading: isLoadingCompanies } = useQuery({
    queryKey: [EQueryKeys.CompaniesQueryKey],
    queryFn: companiesQuery,
    enabled: Boolean(user?.personal.phone),
  });

  useEffect(() => {
    setIsLoading(isLoadingCompanies || isLoadingUser);
  }, [isLoadingCompanies, isLoadingUser]);

  useEffect(() => {
    if (!user) return;

    setUser(user as User);
  }, [user]);

  useEffect(() => {
    if (!companies?.count) return;

    const company = companies.nodes[0];

    setCompany(company as Company);
    setCompanyId(company.id);
  }, [companies]);

  return isLoading;
};
